import { useTranslation } from "react-i18next";

import { cn } from "utils/cn";

import { ReactComponent as Mic } from "assets/mic.svg";
import { ReactComponent as Pause } from "assets/pause.svg";

interface VoiceRecorderButtonProps {
  recordingState: "idle" | "recording" | "paused" | "stopped";
  handleButtonClick: () => void;
}

export default function VoiceRecorderButton({ recordingState, handleButtonClick }: VoiceRecorderButtonProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center mt-6 absolute -top-1 left-1/2 transform -translate-x-1/2">
      <button
        onClick={handleButtonClick}
        className={cn(
          "w-[150px] h-[150px] rounded-full flex items-center justify-center transition-colors duration-200 focus:outline-none cursor-pointer",
          recordingState === "idle"
            ? "bg-general-green-800 border-0"
            : recordingState === "paused"
              ? "bg-general-green-800 border-0"
              : "bg-white border border-red-500",
        )}
        type="button"
      >
        {recordingState === "idle" && <Mic className="w-16 h-16 fill-white" />}
        {recordingState === "recording" && <Pause className="w-16 h-16 fill-red-500" />}
        {recordingState === "paused" && <Mic className="w-16 h-16 fill-white" />}
      </button>
      <span className="mt-4 text-lg font-semibold">
        {recordingState === "idle" && t("session.voiceRecorder.startRecording")}
        {recordingState === "recording" && t("session.voiceRecorder.pause")}
        {recordingState === "paused" && t("session.voiceRecorder.resume")}
      </span>
    </div>
  );
}
